<template>
  <su-page>
    <el-row class="mt30" slot="content">
      <el-row v-html="details.content"></el-row>
    </el-row>
  </su-page>
</template>
<script>

import {cateDetail} from "@/api/api";

export default {
  name: "introduce",
  data() {
    return {
      id: '10',
      details: {},
    }
  },
  created() {
    this.cateDetail()
  },
  mounted() {

  },
  methods: {
    cateDetail() {
      cateDetail({id: this.id}).then(res => {
        if (res.status === 200) {
          this.details = res.data
        }
      })
    }
  }
}
</script>


<style scoped lang="scss">

</style>
